import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import CalendarTimeGrid from "../../CalendarTimeGrid"
import useSearchFilter from "hooks/useSearchFilter"

const Week = ({ date, activeTab, crewIds, equipmentIds, categoryIds, roleIds, onChangeFilters, startHour, endHour }) => {
  const { bookings } = useSelector((state) => state.calendar)
  const [params] = useSearchFilter({ accessAttributes: ["agenda"] })

  const events = useMemo(() => {
    return bookings?.map((booking) => ({
      id: booking?.uuid,
      start: booking?.start_time,
      end: booking?.end_time,
      title: booking?.experience_name,
      date: booking?.date,
      payment_status: booking?.payment_status,
      booking_status: booking?.booking_status,
      assigned_crew: booking?.assigned_crew || [],
      assigned_equipment: booking?.assigned_equipment || [],
      color: booking?.color,
      multi_day: booking?.multi_day,
    }))
  }, [bookings])

  return (
    <CalendarTimeGrid
      type="week"
      date={date}
      events={events}
      agenda={params.agenda === true}
      activeTab={activeTab}
      crewIds={crewIds}
      equipmentIds={equipmentIds}
      categoryIds={categoryIds}
      roleIds={roleIds}
      onChangeFilters={onChangeFilters}
      startHour={startHour}
      endHour={endHour}
    />
  )
}

Week.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  activeTab: PropTypes.string,
  crewIds: PropTypes.array,
  equipmentIds: PropTypes.array,
  categoryIds: PropTypes.array,
  roleIds: PropTypes.array,
  onChangeFilters: PropTypes.func,
  startHour: PropTypes.number,
  endHour: PropTypes.number,
}

export default Week
